import React from 'react';

import useAsyncLogo from './useAsyncLogo';
import { LogoId } from '../../../../assets-component-library/images/images.types';
import { LogoImageProps } from './Logo.types';
import styles from './Logo.module.scss';
import logoIdImportMap from './LogoImportMap';

const LogoImage = ({
  className = '',
  isInternal = false,
  logoId = LogoId.LIBERIS_BLACK,
  alt = 'Company Logo',
  src = '',
  children = null,
  width = null,
  heigth = null,
  dataCy = 'logoImage',
}: LogoImageProps) => {
  const shouldFetchLogo = !src && isInternal && !children;

  const [logoSrc, loading, error] = useAsyncLogo({
    asyncFunction: shouldFetchLogo
      ? logoIdImportMap[logoId as keyof typeof logoIdImportMap] || logoIdImportMap.liberisLogoBlack
      : logoIdImportMap.empty,
    defaultValue: '',
  });

  if (shouldFetchLogo && loading) {
    return null;
  }

  if (error) {
    return error.message;
  }

  const imgSrc = shouldFetchLogo ? logoSrc : src;

  return (
    <div className={`${styles.logo} ${className}`} data-cy={dataCy}>
      {children || <img src={imgSrc} alt={alt} width={width} height={heigth} />}
    </div>
  );
};

export default LogoImage;
